import cx from 'classnames';
import PropTypes from 'prop-types';

import './NavigationButtons.scss';

const propTypes = {
  className: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onButtonTopClick: PropTypes.func,
  onButtonMiddleClick: PropTypes.func,
  onButtonBottomClick: PropTypes.func,
};

const defaultProps = {
  className: null,
  style: {},
  onButtonTopClick() {},
  onButtonMiddleClick() {},
  onButtonBottomClick() {},
};

function NavigationButtons({
  className,
  style,
  onButtonTopClick,
  onButtonMiddleClick,
  onButtonBottomClick,
}) {
  return (
    <div className={cx('NavigationButtons', className)} style={style}>
      <button
        className="NavigationButtons__button-top"
        data-testid="navigation-btn-top"
        type="button"
        onClick={onButtonTopClick}
      />
      <div // eslint-disable-line
        className="NavigationButtons__button-middle"
        onClick={onButtonMiddleClick}
      >
        <div className="NavigationButtons__button-middle-icon" />
      </div>
      <button
        className="NavigationButtons__button-bottom"
        type="button"
        onClick={onButtonBottomClick}
      />
    </div>
  );
}

NavigationButtons.propTypes = propTypes;
NavigationButtons.defaultProps = defaultProps;

export default NavigationButtons;
